import { RxDashboard } from "react-icons/rx";
import { BsClipboardData } from "react-icons/bs";
import { FiUsers } from "react-icons/fi";
import { MdOutlineMoodBad } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { FiUser } from "react-icons/fi";

export const links = [
    {
        title: <FormattedMessage id="dashboard" defaultMessage={"Dashboard"} />,
        Icon: RxDashboard,
        to: "/",
    },
    {
        title: <FormattedMessage id="job_management" defaultMessage={"Job Management"} />,
        Icon: BsClipboardData,
        to: "/job-management",
    },
    {
        title: <FormattedMessage id="quality_control_cycle" defaultMessage={"Quality Control Cycle"} />, 
        Icon: BsClipboardData,
        to: "/quality-control-cycle",
    },
    {
        title: <FormattedMessage id="quality_defects" defaultMessage={"Quality Defects"} />, 
        Icon: MdOutlineMoodBad,
        to: "/quality-defects",
    },
    // {
    //     title: "Jobs",
    //     Icon: LuClipboardSignature,
    //     to: "/jobs",
    // },
    {
        title: <FormattedMessage id="users" defaultMessage={"Users"} />,
        Icon: FiUsers,
        to: "/users",
    },
    {
        title: <FormattedMessage id="profile" defaultMessage={"Profile"} />,
        Icon: FiUser,
        to: "/profile",
    },
    // {
    //     title: "Settings",
    //     Icon: RxDashboard,
    //     to: "/",
    //     links: [
    //         {
    //             title: "Dashboard",
    //             Icon: RxDashboard,
    //             to: "/members",
    //         },
    //         {
    //             title: "Dashboard",
    //             Icon: RxDashboard,
    //             to: "/teams",
    //         },
    //         {
    //             title: "Dashboard",
    //             Icon: RxDashboard,
    //             to: "/events",
    //         },
    //     ]

    // },
]